import logoDatabrain from '@/pages/opinion/assets/svg/logo-databrain.svg';
import logoLevel from '@/pages/opinion/assets/svg/logo-level-infinite.svg';
import logoLevelUp from '@/pages/opinion/assets/svg/logo-level-up.svg';

export const newsDataSourceIconMap: {
  [key in string]: string;
} = {
  'IEGG PR': logoLevel,
  DataBrain: logoDatabrain,
  LevelUp: logoLevelUp,
};

export const newsDataSourceColorMap: {
  [key in string]: string;
} = {
  'IEGG PR': '#7064FF',
  DataBrain: '#3C7BFF',
  LevelUp: '#A998FF',
};
